<template functional>
	<b-card class="widget mb-4" :class="props.class" :id="props.id" :no-body="props.noBody">
		<div class="widget-title mb-3" v-if="props.header !== null">{{ props.header }}</div>
		<div class="text-center" v-if="props.loading">
			<b-spinner />
		</div>
		<slot v-else />
	</b-card>
</template>

<script>
export default {
	props: {
		header: { default: null },
		class: { default: null },
		id: { default: null },
		height: { default: null },
		loading: { default: true },
		noBody: { default: true }
	}
};
</script>

<style lang="scss">
@import '../../variables';
@import '../../mixins';

.widget {
	background-color: $widget-bg;
	@include card(1);

	.widget-title {
		font-size: 15px;
		color: $widget-title-color;
		opacity: 0.75;
	}
}
</style>
